var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useCallback, useMemo } from "react";
import styled from "styled-components";
import { useKanbanDispatch } from "./context";
var Panel = styled.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
    var theme = _a.theme, cardHeight = _a.cardHeight;
    return "\n  background-color: ".concat(theme.bgContent(), ";\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: repeat(auto-fill, ").concat(cardHeight, ");\n  grid-gap: .5rem;\n  padding: .5rem;\n  align-items: start;\n");
});
export var KanbanPanel = function (_a) {
    var children = _a.children, _b = _a.cardHeight, cardHeight = _b === void 0 ? "50px" : _b, id = _a.id, tags = _a.tags;
    var kanbanDispatch = useKanbanDispatch();
    var dataId = useMemo(function () { return "panel_".concat(id); }, [id]);
    var handleMouseOver = useCallback(function (e) {
        var identifier = e.target.dataset.identifier;
        if (identifier === dataId) {
            console.log("over");
            kanbanDispatch([
                { type: "HANDLE_MOUSE_ENTER_PANEL", payload: id },
                { type: "HANDLE_MOUSE_ENTER_TAG", payload: tags[0] },
            ]);
        }
    }, [kanbanDispatch, id, tags, dataId]);
    var handleMouseOut = useCallback(function (e) {
        var identifier = e.target.dataset.identifier;
        if (identifier === dataId) {
            console.log("out");
            kanbanDispatch([{ type: "HANDLE_MOUSE_LEAVE_PANEL" }, { type: "HANDLE_MOUSE_LEAVE_TAG" }]);
        }
    }, [kanbanDispatch, dataId]);
    return (React.createElement(Panel, { "data-identifier": dataId, onMouseEnter: handleMouseOver, onMouseLeave: handleMouseOut, cardHeight: cardHeight }, children));
};
var templateObject_1;
